<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [ngModel]="searchText()"
    (ngModelChange)="searchText.set($event); filterOptions()"
    (focus)="showOptions()"
    (click)="showOptions()"
    (blur)="onBlur()"
    [disabled]="disabled"
    [attr.aria-invalid]="hasListValidationError()"
  />

  <button
    *ngIf="clearable && !multiple && !disabled && lastSelectedText"
    matSuffix
    type="button"
    class="autocomplete-clear-button"
    [attr.aria-label]="'autocomplete.clear_selection' | translate"
    (mousedown)="$event.preventDefault()"
    (click)="clearSelection($event)"
  ></button>

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayOptionValue"
    (optionSelected)="selectValue($event)"
  >
    <mat-option
      *ngFor="let item of filteredList()"
      [value]="getOptionValue(item)"
    >
      <input
        *ngIf="multiple"
        class="multiple-option-checkbox"
        type="checkbox"
        tabindex="-1"
        aria-hidden="true"
        [checked]="isOptionSelected(item)"
      />
      {{ formatterFn(item, item[propertyName]) }}
    </mat-option>

    <mat-option
      *ngIf="!multiple && !allowOnlyListValues && searchText()"
      [value]="searchText()"
    >
      {{ searchText() }}
    </mat-option>
  </mat-autocomplete>

  <mat-hint
    *ngIf="hasListValidationError()"
    class="list-validation-error"
    role="alert"
  >
    {{ invalidListValueMessage }}
  </mat-hint>
</mat-form-field>
